import React, { useEffect, useRef, useState } from "react";
import "./BybBonusDecks.css"
// import bonus from "../../assets/images/bonus.svg"
function BybBonusDecks() {
const [systemInfo, setSystemInfo] = useState({
    platform: "",
    userAgent: "",
    cpuCores: 0,
  });

  useEffect(() => {
    const fetchSystemInfo = () => {
      const platform = navigator.platform || 'Unknown';
      const userAgent = navigator.userAgent || 'Unknown';
      const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
      setSystemInfo({ platform, userAgent, cpuCores });
    };

    fetchSystemInfo();
  }, []);

  

  useEffect(() => {
    const detectMacArchitecture = () => {
     const check_list =   document.body.querySelector('.check_list');
     const bybAnalysis =   document.body.querySelector('.byb-analysis');
     const bybAudit =   document.body.querySelector('.byb-audit');
     const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
     const panel =   document.body.querySelector('.panel.red');
     const legacy =   document.body.querySelector(' .legacy-content');

    
      const body = document.body;
      
      const { platform, cpuCores } = systemInfo;

      if (platform.includes('Win')) {
        // legacy.style.backgroundColor ="brown"
        body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
        check_list.style.background ="rgb(7 26 40)"
        bybAnalysis.style.background ="rgb(7 26 40)"
        bybAudit.style.background="rgb(7 26 40)"
        check_list_believe.style.background="rgb(7 26 40)"
        panel.style.background="rgb(7 26 40)"
        legacy.style.background="rgb(7 26 40)"
        
        // check_list_believe
      }
       else if (platform.includes('Mac'))
         {  
        if (cpuCores >= 8) {
          body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
          check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
          panel.style.background="hwb(202.33deg 0.78% 82.35%)"
          legacy.style.background="hwb(202.33deg 0.78% 82.35%)"

        } else {
          body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
          check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
          panel.style.background="hwb(204.29deg 1.18% 82.35%)"
          legacy.style.background="hwb(204.29deg 1.18% 82.35%)"

        }
      } 
   
    };

    detectMacArchitecture();
  }, [systemInfo]); // Added systemInfo as a dependency to useEffect


  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  return (
<>
<section className='byb-bonus'>
<div className='container'>
<div className='byb-bonus-header'>
 <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}>IN KIT</p>
<h1>Bonus Decks</h1>
</div>

<div className='row'>
    <div className='col-lg-6'>
<div className='byb-bonus-firsthalf'>
    <div className='bonus-left-part'>
      <div className="card_num">
      <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/26.svg" alt="Twenty six bonus tips marker" />
      <p className='bonus-left-firstp'>Tips For Maintaining A Strong Brand</p>
      </div>
      <div className="card_num_txt">
      <p>Simple Yet Powerful Actions to Keep Your Brand Thriving</p>
      </div>
    </div>
    <div className='bonus-right-part'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/26_tips.svg" alt="Tips for maintaining a strong brand bonus deck cover" />
    </div>

</div>
    </div>
    <div className='col-lg-6'>
    <div className='byb-bonus-secondhalf'>
    <div className='bonus-left-part'>
<div className="card_num">
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/26.svg" alt="Twenty six bonus tactics marker" />
<p className='bonus-left-firstp'>Tactics To Master Marketing</p>
</div>
<div className="card_num_txt">
<p>Effective Tactics to Amplify Your Brand’s Reach</p>
</div>
    </div>
    <div className='bonus-right-part'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/26_tactics.svg" alt="Tactics to master marketing bonus deck cover" />
    </div>

</div>
    </div>

</div>


</div>
</section>


</>
  )
}

export default BybBonusDecks
